import React from "react";
import { Card, Icon, Grid, Chip } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import gif from "assets/images/welcome-profile.png";
import { useTranslation } from "react-i18next";
import { ReactComponent as DonutsLove } from 'assets/svgs/donutsLove.svg';

const WelcomeMark = () => {
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        height: { xs: "auto", md: "340px" },
        minHeight: { xs: "200px" },
        py: { xs: "24px", md: "32px" },
        backgroundImage: `linear-gradient(135deg, rgba(6,11,40,0.92) 0%, rgba(67,24,255,0.55) 60%, rgba(0,117,255,0.30) 100%), url(${gif})`,
        backgroundSize: "cover",
        backgroundPosition: "50%",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.07)",
        overflow: "hidden",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "2px",
          background: "linear-gradient(90deg, #4318ff, #0075ff, #21d4fd)",
          opacity: 0.8,
        },
      }}
    >
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={7} md={8} lg={9}>
          <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
            <VuiBox>
              <Chip
                label={t('welcomeCommunity')}
                size="small"
                sx={{
                  mb: "14px",
                  background: "rgba(67,24,255,0.35)",
                  border: "1px solid rgba(67,24,255,0.6)",
                  color: "#a78bfa",
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  letterSpacing: "0.06em",
                  height: "22px",
                  backdropFilter: "blur(8px)",
                }}
              />
              <VuiTypography
                color="white"
                variant="h3"
                fontWeight="bold"
                mb="14px"
                sx={{
                  lineHeight: 1.2,
                  textShadow: "0 2px 12px rgba(0,0,0,0.4)",
                }}
              >
                {t('explorePlayConnect')}
              </VuiTypography>
              <VuiTypography
                color="text"
                variant="body2"
                fontWeight="regular"
                mb="auto"
                sx={{ opacity: 0.85, lineHeight: 1.5 }}
              >
                {t('createJoinEvents')}
              </VuiTypography>
            </VuiBox>
            <VuiBox
              component="a"
              href="upcoming-games"
              display="inline-flex"
              alignItems="center"
              sx={{
                mt: "20px",
                px: "18px",
                py: "8px",
                borderRadius: "8px",
                background: "linear-gradient(97.89deg, #4318ff, #0075ff)",
                width: "fit-content",
                textDecoration: "none",
                boxShadow: "0 4px 20px rgba(67,24,255,0.45)",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 24px rgba(67,24,255,0.65)",
                },
                "& .material-icons-round": {
                  fontSize: "1rem",
                  transform: "translate(2px, -0.5px)",
                  transition: "transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)",
                },
                "&:hover .material-icons-round": {
                  transform: "translate(5px, -0.5px)",
                },
              }}
            >
              <VuiTypography variant="button" color="white" fontWeight="medium" sx={{ mr: "4px" }}>
                {t('discoverEvents')}
              </VuiTypography>
              <Icon sx={{ color: "#fff", fontWeight: "bold" }}>arrow_forward</Icon>
            </VuiBox>
          </VuiBox>
        </Grid>
        <Grid item xs={5} md={4} lg={3}>
          <VuiBox
            sx={{
              filter: "drop-shadow(0 8px 24px rgba(67,24,255,0.4))",
              transform: "scale(1.05)",
            }}
          >
            <DonutsLove style={{ width: '100%', height: 'auto' }} />
          </VuiBox>
        </Grid>
      </Grid>
    </Card>
  );
};

export default WelcomeMark;
